import { MapPin, Phone, Mail, Instagram, Clock } from "lucide-react";
import { CONTACT, WHATSAPP_NUMBER } from "@/lib/data";
import { useContent } from "@/context/ContentContext";

export const Contact = () => {
  const { content } = useContent();
  const c = { ...CONTACT, ...(content.contact || {}) };
  const waNum = c.whatsappNumber || WHATSAPP_NUMBER;
  const info = [
    { icon: MapPin, label: "Alamat Studio", value: c.alamat },
    { icon: Phone, label: "WhatsApp / Telp", value: c.whatsapp },
    { icon: Mail, label: "Email", value: c.email },
    { icon: Instagram, label: "Instagram", value: c.instagram },
    { icon: Clock, label: "Jam Operasional", value: c.jam },
  ];
  return (
    <section id="kontak" className="py-24 bg-[#FAF6F0]" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12">
        <div>
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#C5A059] mb-3">
            Kontak
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium text-[#1C1917] tracking-tight">
            Hubungi Kami
          </h2>
          <p className="mt-4 text-[#786F66] max-w-md">
            Tim kami siap membantu mewujudkan dekorasi impian Anda. Hubungi kami
            melalui kanal berikut.
          </p>

          <div className="mt-8 space-y-5">
            {info.map((it) => (
              <div key={it.label} className="flex gap-4" data-testid={`contact-${it.label.split(" ")[0].toLowerCase()}`}>
                <div className="w-11 h-11 rounded-xl bg-white border border-[#E5D7C5] flex items-center justify-center shrink-0">
                  <it.icon className="w-5 h-5 text-[#C5A059]" />
                </div>
                <div>
                  <div className="text-[10px] tracking-widest uppercase text-[#967C52]">
                    {it.label}
                  </div>
                  <div className="text-[#1C1917] font-medium">{it.value}</div>
                </div>
              </div>
            ))}
          </div>

          <a
            href={`https://wa.me/${waNum}`}
            target="_blank"
            rel="noreferrer"
            data-testid="contact-whatsapp-button"
            className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#C5A059] text-white text-xs font-semibold tracking-widest uppercase hover:bg-[#A8833E] transition-all"
          >
            Chat WhatsApp Admin
          </a>
        </div>

        <div className="rounded-3xl overflow-hidden border border-[#E5D7C5] min-h-[400px] shadow-[0_4px_20px_rgba(28,25,23,0.05)]">
          <iframe
            title="Lokasi Ascarya Dekorasi"
            src={c.mapsEmbed || "https://www.google.com/maps?q=-8.5783936,115.3052787&z=17&output=embed"}
            className="w-full h-full min-h-[400px] border-0"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};
